
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tools/coupons",
      function () {
        return require("private-next-pages/[locale]/tools/coupons/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tools/coupons"])
      });
    }
  